import Form from '@utils/form'
import http from '@plugin/axios'
import NoEvaluationSysTable from './components/NoEvaluationSysTable.vue'
import MarkBase from './components/MarkBase.vue'

// import { $t } from '@plugin/i18n'

export function saveCheck(vm: any) {
  console.log(vm.data)
  return false
}

async function submit(this: any) {
  if (!saveCheck(this)) {
    const params = { ...this.data.markBase, detailList: this.data.detailList.groupData }
    await http({
      url: '/examineProcess/addProcessMarks',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: params,
      loading: true
    }).then(() => {
      http({
        url: '/examineProcess/setProcessStatus',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { assessSystemNo: params.assessSystemNo, processNo: params.processNo },
        loading: true
      })
    })
    this.$router.back()
  }
}
async function getData(vm: any) {
  const params = {
    processNo: vm.$route.params.processNo,
    purchaseUnitNo: vm.$route.params.purchaseUnitNo,
    assessSystemNo: vm.$route.params.assessSystemNo,
    judgeType: vm.$route.params.judgeType
  }
  const data = await http<any>({
    url: '/examineProcess/getMarksDetail',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
  vm.data.markBase = {
    mark: true,
    assessSystemName: data.assessSystemName,
    purchaseUnitName: data.purchaseUnitName,
    workingPeriodName: data.workingPeriodName,
    workingDateName: data.workingDateName,
    processNo: data.processNo,
    purchaseUnitNo: data.purchaseUnitNo,
    assessSystemNo: data.assessSystemNo,
    judgeType: data.judgeType
  }
  Reflect.set(vm.data.detailList, 'groupModel', data.groupModel)
  Reflect.set(vm.data.detailList, 'groupData', data.groupData)
  vm.createForm()
}

const buttons = [
  { type: 'primary', text: 'common.commit', handle: submit },
  { type: 'default', text: 'common.cancel', handle(this: any) { this.$router.back() } }
]

export default new Form('performanceAppraisal.performanceAppraisal')
  .type('modify')
  .name('PerformanceAppraisal.PerformanceAppraisal.Mark')
  .dataUrl(getData)
  .url(submit)
  .btns(buttons)
  .addGroup()
  .formItemComponent('markBase', MarkBase, {})
  .addGroup()
  .formItemComponent('detailList', NoEvaluationSysTable, {}).attrs({ isMark: true, isView: false })
  .end()
